import countOffers from 'src/api/count-offers';
import { addOffersToJobAlert } from 'src/redux/actions/job-alerts';


const getOffers = ({ criterias, id }) => async (dispatch, getState, { http }) => {
  const [offers, counterError] = await countOffers({ http, criterias })
    .then(({ data }) => [data.value])
    .catch(error => [null, error]);

  if (!counterError) {
    dispatch(addOffersToJobAlert({
      id,
      offers
    }));
  }
};

export default getOffers;
